export const SingleMarker = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="30"
    viewBox="0 0 32 30"
    fill="none"
  >
    <ellipse
      cx="16.1535"
      cy="27.5376"
      rx="16.1535"
      ry="3.46146"
      fill="#031C2D"
    />
    <path
      d="M15.5765 1C17.8716 1 20.0727 1.91172 21.6956 3.5346C23.3184 5.15747 24.2302 7.35857 24.2302 9.65366C24.2302 13.7463 17.8842 23.9391 16.0623 26.7879C16.0101 26.8694 15.9382 26.9364 15.8533 26.9828C15.7685 27.0293 15.6733 27.0536 15.5765 27.0536C15.4798 27.0536 15.3846 27.0293 15.2997 26.9828C15.2148 26.9364 15.1429 26.8694 15.0908 26.7879C13.2689 23.9403 6.92285 13.7463 6.92285 9.65366C6.92285 7.35857 7.83457 5.15747 9.45745 3.5346C11.0803 1.91172 13.2814 1 15.5765 1V1Z"
      fill="#BF3C2B"
      stroke="#031C2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5767 13.1143C17.4884 13.1143 19.0382 11.5646 19.0382 9.65287C19.0382 7.74116 17.4884 6.19141 15.5767 6.19141C13.665 6.19141 12.1152 7.74116 12.1152 9.65287C12.1152 11.5646 13.665 13.1143 15.5767 13.1143Z"
      fill="#F0F3F6"
      stroke="#031C2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DoubleMarkers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="46"
    viewBox="0 0 44 46"
    fill="none"
  >
    <path
      d="M25.6197 22L24.8499 19.6215L25.6197 22ZM10.8184 15.4934C14.725 15.7779 21.7294 16.8384 25.8794 18.3227C26.9106 18.6915 27.6192 19.0366 28.0309 19.3184C28.5573 19.6787 28.0981 19.573 28.051 18.8758C27.9943 18.0389 28.5966 17.8518 28.0304 18.2465C27.5415 18.5874 26.5672 19.0657 24.8499 19.6215L26.3895 24.3785C28.2772 23.7676 29.8 23.1079 30.8898 22.3482C31.9024 21.6423 33.165 20.3921 33.0395 18.5382C32.9236 16.8241 31.6664 15.7477 30.8551 15.1924C29.9291 14.5585 28.7602 14.0429 27.5633 13.6148C22.8013 11.9116 15.286 10.8055 11.1816 10.5066L10.8184 15.4934ZM24.8499 19.6215C20.3988 21.062 15.3428 22.6255 11.1353 24.2642C9.02659 25.0854 7.05057 25.9556 5.41845 26.8785C3.85266 27.7639 2.31134 28.8558 1.38808 30.2327C0.898389 30.963 0.522654 31.8627 0.500977 32.8989C0.478914 33.9536 0.828852 34.9107 1.39111 35.7251C2.43193 37.2326 4.29319 38.3926 6.55737 39.3839C11.1973 41.4153 19.1889 43.4224 31.5973 45.4667L32.4101 40.5333C20.0345 38.4943 12.5831 36.5638 8.56269 34.8036C6.49668 33.8991 5.72345 33.1997 5.50568 32.8843C5.43864 32.7872 5.50326 32.842 5.49988 33.0035C5.49689 33.1464 5.44385 33.162 5.54088 33.0173C5.79107 32.6442 6.47933 32.0226 7.87949 31.2309C9.21331 30.4767 10.9396 29.7062 12.9498 28.9233C16.9801 27.3537 21.8282 25.8547 26.3895 24.3785L24.8499 19.6215Z"
      fill="#B21B0C"
    />
    <ellipse cx="33" cy="43.5763" rx="11" ry="2.423" fill="#8C9BA5" />
    <path
      d="M32.6067 25C34.1696 25 35.6685 25.6382 36.7736 26.7742C37.8787 27.9102 38.4996 29.4509 38.4996 31.0575C38.4996 33.9223 34.1782 41.0572 32.9375 43.0513C32.902 43.1083 32.853 43.1553 32.7952 43.1878C32.7374 43.2203 32.6726 43.2373 32.6067 43.2373C32.5408 43.2373 32.476 43.2203 32.4182 43.1878C32.3604 43.1553 32.3115 43.1083 32.2759 43.0513C31.0353 41.058 26.7139 33.9223 26.7139 31.0575C26.7139 29.4509 27.3347 27.9102 28.4398 26.7742C29.545 25.6382 31.0438 25 32.6067 25Z"
      fill="#FFDBDD"
      stroke="#8C9BA5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.6067 33.4788C33.9085 33.4788 34.9638 32.394 34.9638 31.0558C34.9638 29.7176 33.9085 28.6328 32.6067 28.6328C31.3048 28.6328 30.2495 29.7176 30.2495 31.0558C30.2495 32.394 31.3048 33.4788 32.6067 33.4788Z"
      fill="white"
      stroke="#8C9BA5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse cx="10.5" cy="13.3839" rx="7.5" ry="1.6153" fill="#8C9BA5" />
    <path
      d="M10.2317 1C11.2973 1 12.3193 1.42546 13.0728 2.18278C13.8263 2.94009 14.2496 3.96724 14.2496 5.03825C14.2496 6.94807 11.3032 11.7046 10.4573 13.034C10.433 13.072 10.3997 13.1033 10.3603 13.1249C10.3208 13.1466 10.2766 13.158 10.2317 13.158C10.1868 13.158 10.1426 13.1466 10.1032 13.1249C10.0638 13.1033 10.0304 13.072 10.0062 13.034C9.1603 11.7051 6.21387 6.94807 6.21387 5.03825C6.21387 3.96724 6.63718 2.94009 7.39067 2.18278C8.14416 1.42546 9.16612 1 10.2317 1Z"
      fill="#FFDBDD"
      stroke="#8C9BA5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2317 6.65247C11.1193 6.65247 11.8388 5.92928 11.8388 5.03717C11.8388 4.14507 11.1193 3.42188 10.2317 3.42188C9.34405 3.42188 8.62451 4.14507 8.62451 5.03717C8.62451 5.92928 9.34405 6.65247 10.2317 6.65247Z"
      fill="white"
      stroke="#8C9BA5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TripleMarkers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="44"
    viewBox="0 0 45 44"
    fill="none"
  >
    <ellipse
      cx="24.2304"
      cy="17.8075"
      rx="10.2304"
      ry="2.19224"
      fill="#031C2D"
    />
    <path
      d="M23.8649 1C25.3184 1 26.7124 1.57742 27.7402 2.60523C28.768 3.63304 29.3455 5.02705 29.3455 6.48059C29.3455 9.07254 25.3264 15.5279 24.1725 17.3322C24.1395 17.3837 24.094 17.4262 24.0402 17.4556C23.9864 17.485 23.9261 17.5004 23.8649 17.5004C23.8036 17.5004 23.7433 17.485 23.6895 17.4556C23.6358 17.4262 23.5903 17.3837 23.5572 17.3322C22.4034 15.5287 18.3843 9.07254 18.3843 6.48059C18.3843 5.02705 18.9617 3.63304 19.9895 2.60523C21.0173 1.57742 22.4113 1 23.8649 1V1Z"
      fill="#E66156"
      stroke="#031C2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.8651 8.67353C25.0758 8.67353 26.0573 7.69204 26.0573 6.4813C26.0573 5.27056 25.0758 4.28906 23.8651 4.28906C22.6543 4.28906 21.6729 5.27056 21.6729 6.4813C21.6729 7.69204 22.6543 8.67353 23.8651 8.67353Z"
      fill="#F0F3F6"
      stroke="#031C2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="11.8461"
      cy="30.4613"
      rx="11.8461"
      ry="2.53845"
      fill="#031C2D"
    />
    <path
      d="M11.4228 11C13.1059 11 14.72 11.6686 15.9102 12.8587C17.1003 14.0489 17.7689 15.663 17.7689 17.3461C17.7689 20.3474 13.1151 27.8223 11.779 29.9114C11.7407 29.9712 11.688 30.0203 11.6258 30.0544C11.5635 30.0884 11.4937 30.1063 11.4228 30.1063C11.3518 30.1063 11.282 30.0884 11.2198 30.0544C11.1575 30.0203 11.1048 29.9712 11.0665 29.9114C9.73048 27.8231 5.07666 20.3474 5.07666 17.3461C5.07666 15.663 5.74527 14.0489 6.93539 12.8587C8.12552 11.6686 9.73968 11 11.4228 11V11Z"
      fill="#E66156"
      stroke="#031C2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4227 19.8835C12.8247 19.8835 13.9612 18.747 13.9612 17.3451C13.9612 15.9431 12.8247 14.8066 11.4227 14.8066C10.0208 14.8066 8.88428 15.9431 8.88428 17.3451C8.88428 18.747 10.0208 19.8835 11.4227 19.8835Z"
      fill="#F0F3F6"
      stroke="#031C2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="30.5381"
      cy="40.8839"
      rx="14.5381"
      ry="3.11531"
      fill="#031C2D"
    />
    <path
      d="M30.0187 17C32.0843 17 34.0653 17.8205 35.5259 19.2811C36.9865 20.7417 37.807 22.7227 37.807 24.7883C37.807 28.4716 32.0956 37.6451 30.4559 40.209C30.4089 40.2824 30.3443 40.3427 30.2679 40.3845C30.1915 40.4263 30.1058 40.4482 30.0187 40.4482C29.9317 40.4482 29.846 40.4263 29.7696 40.3845C29.6932 40.3427 29.6285 40.2824 29.5816 40.209C27.9419 37.6462 22.2305 28.4716 22.2305 24.7883C22.2305 22.7227 23.051 20.7417 24.5116 19.2811C25.9722 17.8205 27.9532 17 30.0187 17V17Z"
      fill="#E66156"
      stroke="#031C2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.0186 27.9015C31.7392 27.9015 33.1339 26.5067 33.1339 24.7862C33.1339 23.0657 31.7392 21.6709 30.0186 21.6709C28.2981 21.6709 26.9033 23.0657 26.9033 24.7862C26.9033 26.5067 28.2981 27.9015 30.0186 27.9015Z"
      fill="#F0F3F6"
      stroke="#031C2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIcon = ({ stroke, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M5.25 5.25L18.75 18.75"
      stroke={stroke || "#5A6872"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 18.75L18.75 5.25"
      stroke={stroke || "#5A6872"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PrevIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.2665 3.36661L3.25817 9.37494H19.1665V10.6249H3.25817L9.2665 16.6249L8.38317 17.5166L0.866505 9.99994L8.38317 2.48328L9.2665 3.36661Z"
      fill="#031C2D"
    />
  </svg>
);

export const NextIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.7335 3.36661L16.7418 9.37494H0.833496V10.6249H16.7418L10.7335 16.6249L11.6168 17.5166L19.1335 9.99994L11.6168 2.48328L10.7335 3.36661Z"
      fill="#031C2D"
    />
  </svg>
);

export const DragAndDrop = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <ellipse cx="24" cy="38.5" rx="24" ry="9.5" fill="#F1F9FF" />
    <path
      d="M33.6307 9H14.3693C13.5359 9 12.7401 9.34665 12.1725 9.95689L5.25 17.4V24H42.75V17.4L35.8275 9.95689C35.2599 9.34665 34.4641 9 33.6307 9Z"
      fill="#c0392b"
      stroke="#ffffff"
    />
    <path
      d="M42 17.75C43.1046 17.75 44 18.6454 44 19.75V38.25C44 39.3546 43.1046 40.25 42 40.25H6C4.89543 40.25 4 39.3546 4 38.25V19.75C4 18.6454 4.89543 17.75 6 17.75H15.3333C16.4379 17.75 17.3022 18.6682 17.6509 19.7162C18.5124 22.3049 21.0293 24.1786 24 24.1786C26.9707 24.1786 29.4876 22.3049 30.3491 19.7162C30.6978 18.6682 31.5621 17.75 32.6667 17.75H42Z"
      fill="#c0392b"
      stroke="#ffffff"
    />
  </svg>
);

export const CircleClose = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16.0003 2.66699C13.3632 2.66699 10.7854 3.44898 8.59273 4.91406C6.40007 6.37915 4.69111 8.46153 3.68194 10.8979C2.67277 13.3342 2.40872 16.0151 2.92319 18.6015C3.43766 21.1879 4.70754 23.5637 6.57224 25.4284C8.43694 27.2931 10.8127 28.563 13.3991 29.0775C15.9855 29.5919 18.6664 29.3279 21.1028 28.3187C23.5391 27.3096 25.6215 25.6006 27.0866 23.4079C28.5517 21.2153 29.3337 18.6374 29.3337 16.0003C29.3337 14.2494 28.9888 12.5156 28.3187 10.8979C27.6487 9.2802 26.6665 7.81035 25.4284 6.57224C24.1903 5.33412 22.7205 4.35199 21.1028 3.68193C19.4851 3.01187 17.7513 2.66699 16.0003 2.66699ZM19.907 18.587L18.5737 19.9203L16.0003 17.3337L13.4137 19.9203L12.0803 18.587L14.667 16.0003L12.0937 13.4137L13.427 12.0803L16.0003 14.667L18.587 12.0803L19.9203 13.4137L17.3337 16.0003L19.907 18.587Z"
      fill={color ?? "#b21b0c"}
    />
  </svg>
);

export const SuccessIcon = () => (
  <svg
    width="280"
    height="200"
    viewBox="0 0 280 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.2575 87.5389C52.2575 87.5389 91.1522 86.1723 99.5573 30.0776C107.021 -19.74 172.608 2.93514 191.567 22.7936C216.126 48.5186 203.034 92.7709 234.804 98.3613C266.575 103.952 245.828 166.106 197.603 160.157C137.612 152.757 152.126 183.514 134.117 196.532C121.192 205.875 68.1966 196.881 66.4303 162.964C64.9439 134.424 51.2226 134.515 41.4968 131.279C27.4699 126.611 18.6315 92.8092 52.2575 87.5389Z"
      fill="white"
    />
    <path
      d="M131 55C121.111 55 111.444 57.9324 103.222 63.4265C94.9991 68.9206 88.5904 76.7295 84.806 85.8658C81.0217 95.0021 80.0315 105.055 81.9608 114.755C83.89 124.454 88.6521 133.363 95.6447 140.355C102.637 147.348 111.546 152.11 121.246 154.039C130.945 155.969 140.998 154.978 150.134 151.194C159.271 147.41 167.079 141.001 172.573 132.779C178.068 124.556 181 114.889 181 105C181 98.4339 179.707 91.9321 177.194 85.8658C174.681 79.7995 170.998 74.2876 166.355 69.6447C161.712 65.0017 156.2 61.3188 150.134 58.806C144.068 56.2933 137.566 55 131 55ZM128 118.55L111.95 102.5L116.95 97.5L128 109L146.25 90.75L151 95.75L128 118.55Z"
      fill="#E8847E"
    />
    <rect x="116" y="69" width="59" height="55" fill="white" />
    <path
      d="M141 45C131.111 45 121.444 47.9324 113.222 53.4265C104.999 58.9206 98.5904 66.7295 94.806 75.8658C91.0217 85.0021 90.0315 95.0555 91.9608 104.755C93.89 114.454 98.6521 123.363 105.645 130.355C112.637 137.348 121.546 142.11 131.246 144.039C140.945 145.969 150.998 144.978 160.134 141.194C169.271 137.41 177.079 131.001 182.573 122.779C188.068 114.556 191 104.889 191 95C191 88.4339 189.707 81.9321 187.194 75.8658C184.681 69.7995 180.998 64.2876 176.355 59.6447C171.712 55.0017 166.2 51.3188 160.134 48.806C154.068 46.2933 147.566 45 141 45ZM138 108.55L121.95 92.5L126.95 87.5L138 99L156.25 80.75L161 85.75L138 108.55Z"
      fill="#E66156"
    />
  </svg>
);

export const EyeOffIcon = ({ title, ...props }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title && <title>{title}</title>}
      <path d="M432 448a15.92 15.92 0 0 1-11.31-4.69l-352-352a16 16 0 0 1 22.62-22.62l352 352A16 16 0 0 1 432 448zm-176.34-64c-41.49 0-81.5-12.28-118.92-36.5-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 0 0 .14-2.94L93.5 161.38a2 2 0 0 0-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0 0 75.8-12.58 2 2 0 0 0 .77-3.31l-21.58-21.58a4 4 0 0 0-3.83-1 204.8 204.8 0 0 1-51.16 6.47zm235.18-145.4c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 0 0-74.89 12.83 2 2 0 0 0-.75 3.31l21.55 21.55a4 4 0 0 0 3.88 1 192.82 192.82 0 0 1 50.21-6.69c40.69 0 80.58 12.43 118.55 37 34.71 22.4 65.74 53.88 89.76 91a.13.13 0 0 1 0 .16 310.72 310.72 0 0 1-64.12 72.73 2 2 0 0 0-.15 2.95l19.9 19.89a2 2 0 0 0 2.7.13 343.49 343.49 0 0 0 68.64-78.48 32.2 32.2 0 0 0-.1-34.78z"></path>
      <path d="M256 160a95.88 95.88 0 0 0-21.37 2.4 2 2 0 0 0-1 3.38l112.59 112.56a2 2 0 0 0 3.38-1A96 96 0 0 0 256 160zm-90.22 73.66a2 2 0 0 0-3.38 1 96 96 0 0 0 115 115 2 2 0 0 0 1-3.38z"></path>
    </svg>
  );
};

export const EyeOnIcon = ({ title, ...props }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112z"
      ></path>
      <circle
        cx="256"
        cy="256"
        r="80"
        fill="none"
        strokeMiterlimit="10"
        strokeWidth="32"
      ></circle>
    </svg>
  );
};

export const SearchIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill={MOBILE_ICON_COLOR}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7237 14.2075H15.7227L15.377 13.8775C16.6543 12.4689 17.3557 10.6674 17.3523 8.8045C17.3523 4.49419 13.6917 1 9.17614 1C4.66058 1 1 4.49419 1 8.8045C1 13.1148 4.66058 16.609 9.17614 16.609C11.1266 16.6116 13.0129 15.9445 14.4907 14.7295L14.8364 15.0595V16.009L21.1253 22L23 20.2105L16.7237 14.2075ZM9.17614 14.2075C6.04962 14.2075 3.51507 11.7882 3.51507 8.80375C3.51507 5.81934 6.04962 3.4 9.17614 3.4C12.3027 3.4 14.8372 5.81934 14.8372 8.80375C14.8372 11.7882 12.3027 14.2075 9.17614 14.2075Z"
    />
  </svg>
);

export const MOBILE_ICON_COLOR = "#414142";

export const MapIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_3765_10541)">
      <path
        d="M3.5 3L3.66 3.03L9 5.1L15 3L20.64 4.9C20.85 4.97 21 5.15 21 5.38V20.5C21 20.78 20.78 21 20.5 21L20.34 20.97L15 18.9L9 21L3.36 19.1C3.15 19.03 3 18.85 3 18.62V3.5C3 3.22 3.22 3 3.5 3ZM9 19L15 16.89V5L9 7.11L9 19Z"
        fill={MOBILE_ICON_COLOR}
      />
    </g>
    <defs>
      <clipPath id="clip0_3765_10541">
        <rect width="24" height="24" rx="8" transform="matrix(-1 0 0 1 24 0)" />
      </clipPath>
    </defs>
  </svg>
);

export const ListIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M8 6H21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={MOBILE_ICON_COLOR}
    />
    <path
      d="M8 12H21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={MOBILE_ICON_COLOR}
    />
    <path
      d="M8 18H21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={MOBILE_ICON_COLOR}
    />
    <circle cx="3" cy="6" r="1" fill={MOBILE_ICON_COLOR} />
    <circle cx="3" cy="12" r="1" fill={MOBILE_ICON_COLOR} />
    <circle cx="3" cy="18" r="1" fill={MOBILE_ICON_COLOR} />
  </svg>
);

export const InsightsIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_3765_10561)">
      <path
        d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z"
        fill={MOBILE_ICON_COLOR}
      />
    </g>
    <defs>
      <clipPath id="clip0_3765_10561">
        <rect width="24" height="24" fill={MOBILE_ICON_COLOR} />
      </clipPath>
    </defs>
  </svg>
);

export const FilterIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill={window.isSmall ? MOBILE_ICON_COLOR : "currentColor"}
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="none" d="M0 0h24m0 24H0"></path>
    <path d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0 0 18.95 4H5.04c-.83 0-1.3.95-.79 1.61z"></path>
    <path fill="none" d="M0 0h24v24H0V0z"></path>
  </svg>
);

export const ArrowDownIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={MOBILE_ICON_COLOR}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.41009 6.91107C4.73553 6.58563 5.26317 6.58563 5.5886 6.91107L9.99935 11.3218L14.4101 6.91107C14.7355 6.58563 15.2632 6.58563 15.5886 6.91107C15.914 7.23651 15.914 7.76414 15.5886 8.08958L10.5886 13.0896C10.2632 13.415 9.73553 13.415 9.41009 13.0896L4.41009 8.08958C4.08466 7.76414 4.08466 7.23651 4.41009 6.91107Z"
    />
  </svg>
);

export const ArrowUpIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={MOBILE_ICON_COLOR}
    transform="rotate(180)"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.41009 6.91107C4.73553 6.58563 5.26317 6.58563 5.5886 6.91107L9.99935 11.3218L14.4101 6.91107C14.7355 6.58563 15.2632 6.58563 15.5886 6.91107C15.914 7.23651 15.914 7.76414 15.5886 8.08958L10.5886 13.0896C10.2632 13.415 9.73553 13.415 9.41009 13.0896L4.41009 8.08958C4.08466 7.76414 4.08466 7.23651 4.41009 6.91107Z"
    />
  </svg>
);

export const ArrowLeftIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill={MOBILE_ICON_COLOR}
    strokeWidth="0"
    viewBox="0 0 448 512"
    height="20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" />
  </svg>
);

export const PrintIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill={window.isSmall ? MOBILE_ICON_COLOR : "currentColor"}
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="18px"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M408 112H106a58 58 0 0 0-58 58v158a56 56 0 0 0 56 56h8v39.68A40.32 40.32 0 0 0 152.32 464h207.36A40.32 40.32 0 0 0 400 423.68V384h8a56 56 0 0 0 56-56V168a56 56 0 0 0-56-56zm-40 311.68a8.35 8.35 0 0 1-8.32 8.32H152.32a8.35 8.35 0 0 1-8.32-8.32V264.32a8.35 8.35 0 0 1 8.32-8.32h207.36a8.35 8.35 0 0 1 8.32 8.32zm26-215.76a24 24 0 1 1 22-22 24 24 0 0 1-22 22zM344 48H168a56.09 56.09 0 0 0-55.42 48h286.84A56.09 56.09 0 0 0 344 48z"></path>
  </svg>
);

export const GlobeIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill={MOBILE_ICON_COLOR}
    strokeWidth="0"
    viewBox="0 0 1024 1024"
    height="18px"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1025.02 512c0-272.016-213.663-495.104-482.319-511.023-5.536-.608-11.088-1.009-16.72-1.009-1.664 0-3.328.176-4.992.224-2.992-.048-5.968-.224-8.992-.224C229.117-.032-1.026 229.664-1.026 512s230.144 512.032 513.023 512.032c3.024 0 6-.176 9.008-.24 1.664.064 3.328.24 4.992.24 5.632 0 11.184-.4 16.72-1.009 268.64-15.92 482.304-238.976 482.303-511.023zm-95.451 164.832c-17.632-5.12-61.92-16.24-140.064-25.392 6.464-44.192 10-90.896 10-139.44 0-38.256-2.208-75.343-6.288-111.008 99.008-11.824 142.384-26.72 145.296-27.745l-11.92-33.584c22.24 53.088 34.56 111.296 34.56 172.336 0 58.193-11.28 113.761-31.583 164.833zM285.488 512.001c0-35.808 2.37-70.77 6.705-104.401 51.888 4.08 113.936 7.088 186.863 7.792v222.064c-70.992.688-131.664 3.568-182.688 7.473-7.04-42.193-10.88-86.88-10.88-132.928zM542.945 68.223c78.464 22.736 145.648 131.695 175.744 276.111-48.368 3.856-106.624 6.673-175.744 7.33V68.223zm-63.886.783V351.63c-68.368-.688-126.88-3.473-176.063-7.232C333.7 201.79 401.428 93.646 479.059 69.006zm0 632.223l.001 253.743c-72.4-22.976-136.192-118.575-169.36-247.023 47.76-3.504 104.096-6.063 169.359-6.72zm63.888 254.543l-.001-254.56c65.952.623 122.064 3.28 169.217 6.928-32.608 130.128-96 226.416-169.216 247.632zm-.001-318.32l.001-222.032c73.311-.688 134.991-3.776 186.191-8a844.922 844.922 0 0 1 6.496 104.592c0 46.128-3.712 90.864-10.528 133.12-50.416-4.08-110.8-7.008-182.16-7.68zm371.858-323.52c-9.664 3.008-50.063 14.48-131.023 24.032-18.048-95.952-50.672-177.968-93.12-237.168C788.197 143.18 867.797 219.1 914.805 313.932zM358.82 90.589c-52.208 59.952-94.832 146.161-118.096 248.113-72.48-7.856-115.921-17.089-133.312-21.281 50.72-104.64 141.04-186.752 251.408-226.832zM83.637 377.182c12.32 3.344 58.913 14.941 145.553 24.525a795.86 795.86 0 0 0-7.68 110.305c0 48.273 4.368 94.721 12.24 138.688-74.4 8.033-120.16 17.649-140.688 22.609-19.44-50.096-30.208-104.447-30.208-161.312 0-46.96 7.312-92.256 20.783-134.815zm37.457 355.166c23.264-4.944 64.912-12.464 126.592-18.928 24.288 89.712 63.792 165.616 111.136 219.968-101.12-36.72-185.296-108.752-237.728-201.04zM690.662 923.18c38.224-53.264 68.48-125.024 87.296-208.801 63.408 7.28 103.216 15.792 123.296 20.864-48.016 83.072-121.855 149.393-210.592 187.937z"></path>
  </svg>
);

export const QuestionIcon = ({ ...props }) => {
  return (
    <svg
      stroke="currentColor"
      fill={window.isSmall ? MOBILE_ICON_COLOR : "currentColor"}
      strokeWidth="0"
      viewBox="0 0 16 16"
      height="18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
      <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"></path>
    </svg>
  );
};
export const ReportIcon = ({ ...props }) => {
  return (
    <svg
      stroke={MOBILE_ICON_COLOR}
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height="18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z"></path>
    </svg>
  );
};

export const EditIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="200px"
    width="200px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.263 2.177a1.75 1.75 0 0 1 2.474 0l2.586 2.586a1.75 1.75 0 0 1 0 2.474L19.53 10.03l-.012.013L8.69 20.378a1.753 1.753 0 0 1-.699.409l-5.523 1.68a.748.748 0 0 1-.747-.188.748.748 0 0 1-.188-.747l1.673-5.5a1.75 1.75 0 0 1 .466-.756L14.476 4.963ZM4.708 16.361a.26.26 0 0 0-.067.108l-1.264 4.154 4.177-1.271a.253.253 0 0 0 .1-.059l10.273-9.806-2.94-2.939-10.279 9.813ZM19 8.44l2.263-2.262a.25.25 0 0 0 0-.354l-2.586-2.586a.25.25 0 0 0-.354 0L16.061 5.5Z"
      fill={props.fill ?? "#8C9BA5"}
    ></path>
  </svg>
);

export const BsTableIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    height="200px"
    width="200px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 2h-4v3h4zm0 4h-4v3h4zm0 4h-4v3h3a1 1 0 0 0 1-1zm-5 3v-3H6v3zm-5 0v-3H1v2a1 1 0 0 0 1 1zm-4-4h4V8H1zm0-4h4V4H1zm5-3v3h4V4zm4 4H6v3h4z"></path>
  </svg>
);

export const BiMapAltIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="200px"
    width="200px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m21.447 6.105-6-3a1 1 0 0 0-.895 0L9 5.882 3.447 3.105A1 1 0 0 0 2 4v13c0 .379.214.725.553.895l6 3a1 1 0 0 0 .895 0L15 18.118l5.553 2.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851V7c0-.379-.214-.725-.553-.895zM10 7.618l4-2v10.764l-4 2V7.618zm-6-2 4 2v10.764l-4-2V5.618zm16 12.764-4-2V5.618l4 2v10.764z"></path>
  </svg>
);

export const FaFileArchiveIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 384 512"
    height="200px"
    width="200px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"></path>
  </svg>
);

export const LocateIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill={MOBILE_ICON_COLOR}
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M20.94 11A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
  </svg>
);

export const FaSearchLocation = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 512 512"
    fill="currentColor"
    {...props}
  >
    <path
      d="M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0 0 25.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
    />
    <circle
      cx="256"
      cy="192"
      r="48"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
    />
  </svg>
);

export const FaChevronRight = (props) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 320 512"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path>
    </svg>
  );
};

export const BSLightning = (props) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    viewBox="0 0 16 16"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09zM4.157 8.5H7a.5.5 0 0 1 .478.647L6.11 13.59l5.732-6.09H9a.5.5 0 0 1-.478-.647L9.89 2.41z" />
  </svg>
);

export const BSBrush = (props) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    viewBox="0 0 16 16"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.1 6.1 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.1 8.1 0 0 1-3.078.132 4 4 0 0 1-.562-.135 1.4 1.4 0 0 1-.466-.247.7.7 0 0 1-.204-.288.62.62 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896q.19.012.348.048c.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04M4.705 11.912a1.2 1.2 0 0 0-.419-.1c-.246-.013-.573.05-.879.479-.197.275-.355.532-.5.777l-.105.177c-.106.181-.213.362-.32.528a3.4 3.4 0 0 1-.76.861c.69.112 1.736.111 2.657-.12.559-.139.843-.569.993-1.06a3 3 0 0 0 .126-.75zm1.44.026c.12-.04.277-.1.458-.183a5.1 5.1 0 0 0 1.535-1.1c1.9-1.996 4.412-5.57 6.052-8.631-2.59 1.927-5.566 4.66-7.302 6.792-.442.543-.795 1.243-1.042 1.826-.121.288-.214.54-.275.72v.001l.575.575zm-4.973 3.04.007-.005zm3.582-3.043.002.001h-.002z" />
  </svg>
);

export const SaveIcon = ({ fill = "currentColor", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42.00018 42"
      width="16px"
      height="16px"
      {...props}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons">
          <path
            fill={fill}
            d="M37,0H33V10a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V0H2A2,2,0,0,0,0,2V40a2,2,0,0,0,2,2H40.00018a2,2,0,0,0,2-2V5Zm0,36a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V18a1,1,0,0,1,1-1H36a1,1,0,0,1,1,1Z"
          />
          <rect fill={fill} x="7" width="24" height="9" />
        </g>
      </g>
    </svg>
  );
};

export const TargetIcon = ({ style = {}, ...props }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 256 256"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      style={{
        ...style,
        minWidth: props.width || "200px",
        minHeight: props.height || "200px",
      }}
    >
      <path d="M229.26,90.4a108,108,0,0,1-177.63,114A108,108,0,0,1,195.41,43.63l20.1-20.11a12,12,0,0,1,17,17l-96,96a12,12,0,1,1-17-17l24-24a36,36,0,1,0,19.76,39.65,12,12,0,0,1,23.53,4.74,60,60,0,1,1-25.73-62L178.3,60.74a84,84,0,1,0,28.46,38,12,12,0,1,1,22.5-8.35Z" />
    </svg>
  );
};

export const CalendarIcon = ({ style = {}, ...props }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 448 512"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      style={{
        ...style,
        minWidth: props.width || "1em",
        minHeight: props.height || "1em",
      }}
    >
      <path d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z" />
    </svg>
  );
};

export const MdAccessTime = ({ style = {}, ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    style={{
      ...style,
      minWidth: props.width || "16px",
      minHeight: props.height || "16px",
    }}
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
    <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path>
  </svg>
);

export const EditorIcon = ({ ...props }) => {
  return (
    <svg
      aria-hidden="true"
      className="svg"
      fill="currentColor"
      height="100%"
      viewBox="0 0 16 16"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.721 4.007a.965.965 0 0 0-.03-1.385l-1.413-1.414a.965.965 0 0 0-1.385-.03L2.841 11.23l-1.756 4.097a.371.371 0 0 0 .488.487L5.67 14.06l8.607-8.609zM2.624 14.276l.554-1.294.74.74zm2.338-.924L3.55 11.937l8.007-8.008 1.414 1.415zm8.716-8.716l-1.414-1.414 1.09-1.09a.306.306 0 0 1 .433 0l.981.98a.306.306 0 0 1 0 .434z" />
    </svg>
  );
};

export const IoIosCheckmarkCircle = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    viewBox="0 0 512 512"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm106.5 150.5L228.8 332.8h-.1c-1.7 1.7-6.3 5.5-11.6 5.5-3.8 0-8.1-2.1-11.7-5.7l-56-56c-1.6-1.6-1.6-4.1 0-5.7l17.8-17.8c.8-.8 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2l44.4 44.4 122-122.9c.8-.8 1.8-1.2 2.8-1.2 1.1 0 2.1.4 2.8 1.2l17.5 18.1c1.8 1.7 1.8 4.2.2 5.8z" />
  </svg>
);

export const InformationIcon = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7 4.5H11V13H7V4.5Z" fill="white" />
    <path
      d="M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5ZM9 7.125C9.6213 7.125 10.125 6.62132 10.125 6C10.125 5.37868 9.6213 4.875 9 4.875C8.3787 4.875 7.875 5.37868 7.875 6C7.875 6.62132 8.3787 7.125 9 7.125ZM10.5 11.25H9.75V7.875H7.5V9.375H8.25V11.25H7.5V12.75H10.5V11.25Z"
      fill="#8C9BA5"
    />
  </svg>
);

export const BaselineIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="22"
    viewBox="0 0 54 22"
    fill="none"
    {...props}
  >
    <path d="M5 13.0027H7.23C7.6813 14.9914 8.79507 16.7676 10.3886 18.04C11.9821 19.3124 13.9608 20.0055 16 20.0055C18.0392 20.0055 20.0179 19.3124 21.6114 18.04C23.2049 16.7676 24.3187 14.9914 24.77 13.0027H29.23C29.6813 14.9914 30.7951 16.7676 32.3886 18.04C33.9821 19.3124 35.9608 20.0055 38 20.0055C40.0392 20.0055 42.0179 19.3124 43.6114 18.04C45.2049 16.7676 46.3187 14.9914 46.77 13.0027H49C49.5304 13.0027 50.0391 12.792 50.4142 12.4169C50.7893 12.0419 51 11.5332 51 11.0027C51 10.4723 50.7893 9.9636 50.4142 9.58852C50.0391 9.21345 49.5304 9.00274 49 9.00274H46.77C46.3187 7.0141 45.2049 5.23788 43.6114 3.96547C42.0179 2.69305 40.0392 2 38 2C35.9608 2 33.9821 2.69305 32.3886 3.96547C30.7951 5.23788 29.6813 7.0141 29.23 9.00274H24.77C24.3187 7.0141 23.2049 5.23788 21.6114 3.96547C20.0179 2.69305 18.0392 2 16 2C13.9608 2 11.9821 2.69305 10.3886 3.96547C8.79507 5.23788 7.6813 7.0141 7.23 9.00274H5C4.46957 9.00274 3.96086 9.21345 3.58579 9.58852C3.21071 9.9636 3 10.4723 3 11.0027C3 11.5332 3.21071 12.0419 3.58579 12.4169C3.96086 12.792 4.46957 13.0027 5 13.0027ZM33.424 9.00274C33.9184 7.88873 34.808 6.99732 35.9209 6.50047C37.0338 6.00363 38.2913 5.93657 39.4508 6.31222C40.6103 6.68788 41.5895 7.47963 42.1997 8.53473C42.8098 9.58983 43.0076 10.8335 42.7548 12.0258C42.502 13.2181 41.8166 14.2746 40.8309 14.9913C39.8451 15.7081 38.6288 16.0344 37.4167 15.9073C36.2045 15.7801 35.0824 15.2086 34.2668 14.3029C33.4512 13.3972 32.9999 12.2215 33 11.0027C33.0022 10.314 33.1465 9.63311 33.424 9.00274ZM11.424 9.00274C11.9184 7.88873 12.808 6.99732 13.9209 6.50047C15.0338 6.00363 16.2913 5.93657 17.4508 6.31222C18.6103 6.68788 19.5895 7.47963 20.1997 8.53473C20.8098 9.58983 21.0076 10.8335 20.7548 12.0258C20.502 13.2181 19.8166 14.2746 18.8309 14.9913C17.8451 15.7081 16.6288 16.0344 15.4167 15.9073C14.2045 15.7801 13.0824 15.2086 12.2668 14.3029C11.4512 13.3972 10.9999 12.2215 11 11.0027C11.0022 10.314 11.1465 9.63311 11.424 9.00274Z" />
  </svg>
);

export const PlusIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M416 277.333H277.333V416h-42.666V277.333H96v-42.666h138.667V96h42.666v138.667H416v42.666z"></path>
  </svg>
);

export const TrashBin = ({ ...props }) => (
  <svg
    fill="currentColor"
    fillRule="evenodd"
    height="16"
    role="img"
    viewBox="0 0 12 16"
    width="12"
    {...props}
  >
    <path d="M11 4v11c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V4H0V3h12v1h-1zM2 4v11h8V4H2z"></path>
    <path d="M4 6h1v7H4zm3 0h1v7H7zM3 1V0h6v1z"></path>
  </svg>
);

export const IoMdCheckmark = ({ ...props }) => (
  <svg
    stroke="green"
    fill="green"
    strokeWidth="0"
    viewBox="0 0 448 512"
    height="14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
  </svg>
);

export const OutdatedCheckMark = ({ ...props }) => (
  <svg
    stroke="#FF6900"
    fill="#FF6900"
    strokeWidth={0}
    viewBox="0 0 192 512"
    height="14px"
    width="14px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z" />
  </svg>
);

export const FilterMapExtentIcon = ({ ...props }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 122.88 121.66"
    width="16px"
    height="16px"
    stroke="currentColor"
    fill="currentColor"
    {...props}
  >
    <g>
      <path d="M84.54,52.46c8.33,0,15.88,3.39,21.35,8.84c5.47,5.47,8.84,13,8.84,21.35c0,6.09-1.82,11.78-4.92,16.52l13.07,14.24 l-9.02,8.24l-12.6-13.87c-4.79,3.19-10.54,5.05-16.72,5.05c-8.33,0-15.88-3.39-21.35-8.84c-5.47-5.47-8.84-13-8.84-21.35 c0-8.33,3.39-15.88,8.84-21.35C68.66,55.82,76.19,52.46,84.54,52.46L84.54,52.46L84.54,52.46z M75.73,16.58l35.36-16.33 c1.4-0.64,3.03-0.03,3.66,1.37c0.16,0.37,0.27,0.76,0.27,1.17v54.08c-1.66-1.98-4.58-3.79-6.59-5.41V8.16l-28.82,14.3v20.63 c-1.9,0.29-5.9,0.71-7.7,1.26V22.47L43.08,9.77V90.9l3.64,2.84c1.05,3.2,2.49,7.3,4.27,10.08l-11.68-7.05L4.22,117.97 c-1.3,0.8-3.02,0.37-3.79-0.93C0.14,116.59,0,116.09,0,115.59V19.63c0-1.19,0.73-2.2,1.79-2.59L38.15,0.28h0.07l0.07-0.03h0.03 c0.27-0.1,0.53-0.16,0.83-0.16h0.34c0.27,0.03,0.57,0.07,0.83,0.16h0.03l0.07,0.03h0.07l35.36,16.33L75.73,16.58L75.73,16.58 L75.73,16.58z M35.38,90.9V9.77L6.29,22.2v86.59L35.38,90.9L35.38,90.9z M101.21,65.98c-4.27-4.26-10.17-6.91-16.67-6.91 c-6.5,0-12.4,2.65-16.67,6.91c-4.26,4.26-6.91,10.17-6.91,16.67c0,6.5,2.65,12.4,6.91,16.67c4.26,4.26,10.16,6.91,16.67,6.91 c6.5,0,12.4-2.65,16.67-6.91c4.26-4.26,6.91-10.16,6.91-16.67C108.12,76.15,105.47,70.25,101.21,65.98L101.21,65.98L101.21,65.98 L101.21,65.98z" />
    </g>
  </svg>
);

export const VscFilterFilled = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="#4b4b4b"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="none" d="M0 0h24m0 24H0" />
    <path d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0 0 18.95 4H5.04c-.83 0-1.3.95-.79 1.61z" />
    <path fill="none" d="M0 0h24v24H0V0z" />
  </svg>
);

export const HiCursorClick = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 20 20"
    aria-hidden="true"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const PiWarningFill = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 256 256"
    height="16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z"></path>
  </svg>
);

export const LayerListIcon = ({ ...props }) => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    height="100%"
    viewBox="0 0 16 16"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.023 1.023l-8 4.5 8 4.5 8-4.5zm-5.96 4.5l5.96-3.352 5.96 3.352-5.96 3.353zm13.96 3l-8 4.5-8-4.5 1.02-.573 6.98 3.926 6.98-3.926zm-8 6.353l6.98-3.926 1.02.573-7.914 4.452a.175.175 0 0 1-.171 0L.023 11.523l1.02-.573z" />
  </svg>
);

export const BsThreeDotsVertical = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"></path>
  </svg>
);

export const WarningCircleBold = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 256 256"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-12-80V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,172Z"></path>
  </svg>
);

export const FaExclamation = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    viewBox="0 0 192 512"
    height="16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z" />
  </svg>
);

export const PDFAttachmentIcon = (props) => (
  <svg
    stroke="rgb(76,76,76)"
    fill="rgb(76,76,76)"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="none"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z"
    ></path>
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M256 56v120a32 32 0 0 0 32 32h120m-232 80h160m-160 80h160"
    ></path>
  </svg>
);

export const MdOutlineNotificationsActive = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zM7.58 4.08 6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 0 1 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 0 1 3.54 6.42z"></path>
  </svg>
);

export const FiSend = (props) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line x1="22" y1="2" x2="11" y2="13"></line>
    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
  </svg>
);

export const GoGitCompare = (props) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16.5 19.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm3.25-1.75a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501Z"></path>
    <path d="M13.905 1.72a.75.75 0 0 1 0 1.06L12.685 4h4.065a3.75 3.75 0 0 1 3.75 3.75v8.75a.75.75 0 0 1-1.5 0V7.75a2.25 2.25 0 0 0-2.25-2.25h-4.064l1.22 1.22a.75.75 0 0 1-1.061 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM7.5 4.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0ZM4.25 6.5a1.75 1.75 0 1 0-.001-3.501A1.75 1.75 0 0 0 4.25 6.5Z"></path>
    <path d="M10.095 22.28a.75.75 0 0 1 0-1.06l1.22-1.22H7.25a3.75 3.75 0 0 1-3.75-3.75V7.5a.75.75 0 0 1 1.5 0v8.75a2.25 2.25 0 0 0 2.25 2.25h4.064l-1.22-1.22a.748.748 0 0 1 .332-1.265.75.75 0 0 1 .729.205l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0Z"></path>
  </svg>
);

export const ShowMeAroundIcon = (props) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 384 512"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"></path>
    </svg>
  );
};

export const InfoIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"></path>
    <path d="M277 360h-42V235h42v125zm0-166h-42v-42h42v42z"></path>
  </svg>
);

export const MdTranslate = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="m12.87 15.07-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7 1.62-4.33L19.12 17h-3.24z"></path>
  </svg>
);

export const FISidebar = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="9" y1="3" x2="9" y2="21"></line>
  </svg>
);

export const SidebarArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m9 18 6-6-6-6"></path>
  </svg>
);

export const IoDownload = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 20 20"
    aria-hidden="true"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const RightArrowIcon = (props) => (
  <svg
    width={4}
    height={14}
    viewBox={"0 0 8 14"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 13 1 7l6-6"
      stroke={props.color ? props.color : "#333945"}
      strokeWidth={props.strokeWidth ? props.strokeWidth : 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Cross = (props) => (
  <svg
    width={16}
    height={16}
    viewBox={"0 0 24 24"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m5.25 5.25 13.5 13.5M5.25 18.75l13.5-13.5"
      stroke="#5A6872"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const LeftArrowIcon = (props) => (
  <svg
    width={4}
    height={14}
    viewBox={"0 0 8 14"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1 13 6-6-6-6"
      stroke={props.color ? props.color : "#333945"}
      strokeWidth={props.strokeWidth ? props.strokeWidth : 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MdClose = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="16px"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
  </svg>
);

export const SharedInformationIcon = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="#ffffff"
    strokeWidth="0"
    viewBox="0 0 256 256"
    height="30px"
    width="30px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M104,152a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H96A8,8,0,0,1,104,152Zm136-36v60a16,16,0,0,1-16,16H136v32a8,8,0,0,1-16,0V192H32a16,16,0,0,1-16-16V116A60.07,60.07,0,0,1,76,56h76V24a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H168V56h12A60.07,60.07,0,0,1,240,116ZM120,176V116a44,44,0,0,0-88,0v60Zm104-60a44.05,44.05,0,0,0-44-44H168v72a8,8,0,0,1-16,0V72H116.75A59.86,59.86,0,0,1,136,116v60h88Z"></path>
  </svg>
);

export const CiLock = ({ ...props }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="14px"
    width="14px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Lock">
      <g>
        <path d="M17.44,9.33h-1.1V6.4a4.34,4.34,0,0,0-8.68,0V9.33H6.56a2.5,2.5,0,0,0-2.5,2.5v7.61a2.507,2.507,0,0,0,2.5,2.5H17.44a2.507,2.507,0,0,0,2.5-2.5V11.83A2.5,2.5,0,0,0,17.44,9.33ZM8.66,6.4a3.34,3.34,0,0,1,6.68,0V9.33H8.66ZM18.94,19.44a1.511,1.511,0,0,1-1.5,1.5H6.56a1.511,1.511,0,0,1-1.5-1.5V11.83a1.5,1.5,0,0,1,1.5-1.5H17.44a1.5,1.5,0,0,1,1.5,1.5Z"></path>
        <path d="M13,14.95a.984.984,0,0,1-.5.86v1.5a.5.5,0,0,1-1,0v-1.5a.984.984,0,0,1-.5-.86,1,1,0,0,1,2,0Z"></path>
      </g>
    </g>
  </svg>
);

export const GrCircleInformation = ({ ...props }) => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      aria-hidden="true"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      ></path>
    </svg>
  );
};
